module.exports = __webpack_public_path__ + "img/p4.bbc8c5f4.png";